import { formatCurrency } from "@/common/utils/currencyUtils";
import type { ExperienceState } from "@/types/state";

interface TitledArticle {
  title?: string;
  subtitle?: string;
  price?: number;
  currency?: string;
  titleImage?: { filename?: string };
}

type ArticleTitlesProps = {
  experienceState: ExperienceState;
  article?: TitledArticle | null;
};

function displayPrice(article: TitledArticle) {
  if (article.price) {
    return formatCurrency(article.currency, article.price);
  }
  return "";
}

const ARTICLE_DETAILS =
  "article-details tw:[.landscape_.shop-window_&]:[margin:0_16px_30px_16px] tw:[.portrait_.shop-window_&]:[margin:0_16px_0px_16px] tw:[.portrait_.shop-window_&]:text-center";

export default function ArticleTitles({
  experienceState,
  article,
}: ArticleTitlesProps) {
  const metadata = experienceState.experienceData.metadata;

  if (article) {
    const title =
      article.titleImage && article.titleImage.filename ? (
        <img
          className="article-title"
          src={metadata.getAssetUrl(article.titleImage.filename)}
          alt={article.title}
        />
      ) : (
        <h1 className="article-title header-1">{article.title}</h1>
      );

    const price = article.price ? (
      <span className="price">{displayPrice(article)}</span>
    ) : null;

    return (
      <div className={ARTICLE_DETAILS}>
        {title}
        <h2 className="article-subtitle header-2">
          {article.subtitle} {price}
        </h2>
      </div>
    );
  }
  return (
    <div className={ARTICLE_DETAILS}>
      <h1 className="article-title header-1">&nbsp;</h1>
      <h2 className="article-subtitle header-2">&nbsp;</h2>
    </div>
  );
}
